<template>
  <v-container class="pa-0">
    <div sticky-container>
      <SearchArticlesPanel
        :articles="articleTitlesList"
        :loadingData="loadingData"
        :currentArticleTitle="currentArticleTitle"
        @search="runSearch"
        @gotopage="goToPageHandler"
        v-sticky
        sticky-offset="{top: 48}"
        :min-height="78"
        :initialSearchText="initialSearchText"
      ></SearchArticlesPanel>

      <ArticlesNotFound v-if="noArticlesFound"></ArticlesNotFound>

      <ArticlesInfiniteList
        v-if="!noArticlesFound"
        :articles-list="articlesList"
        :error-loading-data="errorLoadingData"
        @addArticlesToBottom="addArticlesToBottomHandler"
        @addArticlesToTop="addArticlesToTopHandler"
        @currentArticleChange="currentArticleChangeHandler"
      ></ArticlesInfiniteList>
    </div>
  </v-container>
</template>

<script>
import ArticlesInfiniteList from '@/components/ArticlesInfiniteList.vue'
import SearchArticlesPanel from '@/components/SearchArticlesPanel.vue'
import ArticlesNotFound from '@/components/ArticlesNotFound.vue'

import Sticky from 'vue-sticky-directive'
import { articlesInfinitListMixin } from '@/components/mixins/articlesInfinitList'

import { showDate } from '@/helpers/helpers.js'

export default {
  directives: { Sticky },
  components: {
    ArticlesInfiniteList,
    SearchArticlesPanel,
    ArticlesNotFound
  },

  mixins: [articlesInfinitListMixin],

  computed: {
    currentArticleTitle() {
      if (this.currentArticle) {
        return (
          this.currentArticle.title +
          ' (' +
          this.showDate(this.currentArticle.event_date, 'D MMMM YYYY') +
          ')'
        )
      }
      return ''
    }
  },

  data() {
    return {
      initialSearchText: ''
    }
  },

  created() {
    this.initialSearchText = this.$store.getters.getArticlesListOptions.searchText
    this.showArticles()
  },

  methods: {
    goToPageHandler(page) {
      this.resetArticlesList()
      this.startpage = page
    },
    runSearch() {
      this.resetArticlesList()

      this.showArticles()
    },
    showArticles() {
      this.filterOptions = this.$store.getters.getArticlesListOptions.options
      this.startpage = this.$store.getters.getArticlesListOptions.page
      let showtitles = this.$store.getters.getArticlesListOptions.showtitles
      if (showtitles) {
        this.fetchArticleTitles()
      }
    },

    showDate
  }
}
</script>

<style></style>
